import { useState, useEffect } from 'react'
import { makeStyles, Grid, Typography, Paper, Button, IconButton } from '@material-ui/core'
import { Form as FinalForm } from 'react-final-form'
import useTranslate from '../../../i18n/useTranslate'
import MyTextfield from '../../../control/textfield/textfield'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { ConnectLineType } from '../../../services/um/useLineLogin'
interface ConnectLineForm {
    onSubmit: (values: ConnectLineType) => void
    onHandelShowPassword: () => void
    showPassword: boolean
}

const ConnectLineForm = ({ onSubmit, onHandelShowPassword, showPassword }: ConnectLineForm) => {
    const classes = useStyles()
    const translate = useTranslate()
    return (
        <Grid container className={classes.root}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <FinalForm onSubmit={onSubmit} initialValues={{}}>
                    {({ handleSubmit, form }) => {
                        return (
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MyTextfield
                                        required
                                        name="username"
                                        materialInputProps={{
                                            disabled: false,
                                            label: `${translate.get('UM.LINE.CONNECT_LINE_FORM.USER_NAME.LABEL')}`,
                                            placeholder: `${translate.get(
                                                'UM.LINE.CONNECT_LINE_FORM.USER_NAME.PLACEHOLDER',
                                            )}`,
                                            size: 'medium',
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MyTextfield
                                        required
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        materialInputProps={{
                                            disabled: false,
                                            label: `${translate.get('UM.LINE.CONNECT_LINE_FORM.PASSWORD.LABEL')}`,
                                            placeholder: `${translate.get(
                                                'UM.LINE.CONNECT_LINE_FORM.PASSWORD.PLACEHOLDER',
                                            )}`,
                                            size: 'medium',
                                        }}
                                        icon={
                                            <IconButton size="small" onClick={onHandelShowPassword}>
                                                {showPassword ? (
                                                    <Visibility style={{ fontSize: '1.2rem' }} />
                                                ) : (
                                                    <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                                )}
                                            </IconButton>
                                        }
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{ marginTop: '16px', marginBottom: '26px' }}
                                >
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        onClick={handleSubmit}
                                        className={classes.loginButton}
                                    >
                                        {'เข้าสู่ระบบ'}
                                    </Button>
                                </Grid>
                            </Grid>
                        )
                    }}
                </FinalForm>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '16px',
    },
    loginButton: {
        backgroundColor: '#db5f8e',
        color: '#fff',
        border: '#db5f8e',
    },
}))

export default ConnectLineForm
